module.exports = __webpack_public_path__ + "static/img/20.1f156ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/events/20.jpg
// module id = ieDb
// module chunks = 1